import React, { useState } from 'react';
import Slider from "react-slick";

import { useNavigate } from '@tanstack/react-router';
import imgChevron from './assets/chevron.svg';
import RewardsModal from './RewardsModal';
import desktopXlargeImage from './assets/desktop_xlarge_explore_banner.png';
import desktopImage from './assets/desktop_large_explore_banner.png';
import mobileImage from './assets/mobile_explore_banner.png';
import { Button, Typography } from '@altify/components';
import { useContent } from '@altify/utils';
import { exploreProductsContent } from '../../explore.content';
import { newsBanners } from './data';
import { NewsBannerType } from 'types/newsbanner';
import { BannerViewItem } from './NewsBannerItem';
import { EVENTS, trackEvent } from 'utils/analytics';
import useAppLanguage from 'hooks/useAppLanguage';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const NewsBanner: React.FC<{
  onClose: () => void;
  banners: NewsBannerType[];
  className?: string;
}> = ({ 
  onClose,
  banners,
  className 
}) => {

  const localizedContent = useContent(exploreProductsContent);
  const language = useAppLanguage();

  const navigate = useNavigate();


  // #endregion
  const mappedBanners = banners.map((banner: NewsBannerType, i: number) => ({
    ...banner,
    image: `${import.meta.env.VITE_ALTIFY_CDN_URL}assets/explore/banner/web/${banner.image}`,
    onPress: () => {
      trackEvent(EVENTS.ADVERT_CLICK, {
        eventFields: {
          advert: banner.id,
        }
      });

      navigate({ to: banner.link });
    },
    hidden: false,
  }));


    
  var settings = {
    dots: mappedBanners?.length > 1 ? true : false, 
    infinite: mappedBanners?.length > 1 ? true : false,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
      <Slider {...settings}>
        {mappedBanners.map((item, i) => (
          <BannerViewItem key={item?.id} mappedBanner={item} onPress={item?.onPress} onClose={onClose} className={className} language={language} />
        ))}

      </Slider>
    </>
  );
};

export default NewsBanner;
